module.exports = __webpack_public_path__ + "static/media/stores2.dce67a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stores/steps/stores2.png
// module id = 2014
// module chunks = 0